(function () {
	const initCollapsibleContent = () => {
		$(".collapsible-content__toggle").unbind("click").on("click", function () {
			const parent = $(this).parent();

			if (!parent.hasClass("active")) {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent.addClass("active");
				$(this)
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(0);
				$(this).next().stop().slideDown(0);
			} else {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(0);
				parent.removeClass("active");
				$(this).next().stop().slideUp(0);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();

(function () {
  var $faqItems = $('.collapsible-content__items .collapsible-content__item').hide(),
    $current;
  $('input:radio').change(function() {
    var $this = $(this);
    $this.addClass('selected');  
    $current = $faqItems.filter('.' + this.id).hide();
    $current.slice(0, 6).show();
    $faqItems.not($current).hide();
     var currentItemLength = $current.length;
     if(currentItemLength > $(".collapsible-content__item:visible").length) {
       $("#loadMore").show();
     }else{
        $("#loadMore").hide();
     } 
    }).filter('.selected').click();
   $("#loadMore").on("click", function(e){
    e.preventDefault();
    var currentItemLength = $current.length;
    $current.filter(':hidden').slice(0, 6).show();
    if($(".collapsible-content__item:visible").length == currentItemLength) {
      $("#loadMore").hide();
    }
  });
})();
